<mc-chart type="bar" [style.width.px]="colAmounts * 60" [options]="chartOptions" [data]="chartData$ | async">
</mc-chart>